import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from "../../../services/apiroutes";
import { IRegisterError, IRegisterModel, RegisterModel } from "./register.model";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RegisterApiService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
  ) { }

  registerUser(data) {
    let url = `${ApiRoutes.Authentication}customer/pre-register/`;
    return this.http.post<IRegisterModel>(url, data)
  }

  verifyEmailOTP(otp_data) {
    let url = `${ApiRoutes.Authentication}customer/verify-otp/`;
    return this.http.post(url, otp_data)
  }

  setPassword(password_data) {
    let url = `${ApiRoutes.Authentication}customer/new-register/`;
    return this.http.post(url, password_data)
  }

  resendOTP(token) {
    let url = `${ApiRoutes.Authentication}customer/resend-email-otp/`;
    console.debug('RegisterApiService.resendOTP() url: ', url);
    return this.http.post<any>(url, token, { observe: 'response' });
  }
}
